import { Controller } from "stimulus"

export default class extends Controller {

  sendMessageCounter = 0

  connect() {
    this.hideSurvey()
  }

  addCounter() {
    this.sendMessageCounter++

    if (this.sendMessageCounter === 3) {
      this.showSurvey()
    }
  }

  showSurvey() {
    const surveySelector = '[class^="PostHogSurvey"]';
    const surveyElement = document.querySelector(surveySelector);

    if (!surveyElement) {
      return;
    }

    const shadowRoot = surveyElement.shadowRoot;
    const style = document.createElement('style');

    if (!shadowRoot) {
      return;
    }

    surveyElement.style.display = 'block';
    const surveyForm = shadowRoot.querySelector('.survey-form');
    if (surveyForm && surveyForm.parentElement) {
      surveyForm.parentElement.classList.add('survey-form-container');
    }

    style.textContent = `
      .survey-form-container {
        bottom: 50px;
        border-bottom: 1.5px solid #c01489;
        border-radius: 10px;
      }

      .survey-form {
        border-radius: 10px;
      }

      @media (max-width: 767px) {
        .survey-form-container {
          right: unset !important;
          left: 50%;
          transform: translateX(-50%) !important;
          bottom: unset;
          top: 110px;
        }
      }
    `;

    shadowRoot.appendChild(style);
  }

  hideSurvey() {
    const style = document.createElement('style');
    style.textContent = `
      [class^="PostHogSurvey"] {
        display: none;
      }
    `;
    document.head.appendChild(style);
  }
}